export default __webpack_public_path__ + "static/Indaka-dbe07284a820ac4c25ddce613a7bb1b8.jpg";